import React, { useEffect, useState } from "react";
import { HiOutlineDocumentText, HiOutlineUser, HiOutlineClock } from "react-icons/hi";
import { utils as XLSXUtils, writeFile as XLSXWriteFile } from 'xlsx';

function unique(arr, key) {
  return Array.from(new Set(arr.map(x => x[key])));
}

export default function LogsPage() {
  const [logs, setLogs] = useState([]);
  const [selectedLog, setSelectedLog] = useState(null);
  const [userFilter, setUserFilter] = useState('');
  const [typeFilter, setTypeFilter] = useState('');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [search, setSearch] = useState('');
  const [sortBy, setSortBy] = useState('created_at');
  const [sortDir, setSortDir] = useState('desc');

  useEffect(() => {
    fetch('/api/logs')
      .then(res => res.json())
      .then(setLogs)
      .catch(() => setLogs([]));
  }, []);

  let filteredLogs = logs.filter(log => {
    if (userFilter && log.user !== userFilter) return false;
    if (typeFilter && log.type !== typeFilter) return false;
    if (dateFrom && new Date(log.created_at) < new Date(dateFrom)) return false;
    if (dateTo && new Date(log.created_at) > new Date(dateTo + 'T23:59:59')) return false;
    if (search) {
      const s = search.toLowerCase();
      if (!(
        (log.user && log.user.toLowerCase().includes(s)) ||
        (log.action && log.action.toLowerCase().includes(s)) ||
        (log.details && log.details.toLowerCase().includes(s))
      )) return false;
    }
    return true;
  });
  filteredLogs = filteredLogs.sort((a, b) => {
    let vA = a[sortBy], vB = b[sortBy];
    if (sortBy === 'created_at') {
      vA = new Date(vA); vB = new Date(vB);
    } else {
      vA = vA || ''; vB = vB || '';
    }
    if (vA < vB) return sortDir === 'asc' ? -1 : 1;
    if (vA > vB) return sortDir === 'asc' ? 1 : -1;
    return 0;
  });

  const userOptions = unique(logs, 'user');
  const typeOptions = unique(logs, 'type');

  // Export fonksiyonları
  function exportExcel() {
    const ws = XLSXUtils.json_to_sheet(filteredLogs.map(l => ({
      Kullanıcı: l.user,
      İşlem: l.action,
      Tür: l.type,
      Zaman: l.created_at,
      Detay: l.details
    })));
    const wb = XLSXUtils.book_new();
    XLSXUtils.book_append_sheet(wb, ws, 'Logs');
    XLSXWriteFile(wb, 'islem_kayitlari.xlsx');
  }
  function exportCSV() {
    const ws = XLSXUtils.json_to_sheet(filteredLogs.map(l => ({
      Kullanıcı: l.user,
      İşlem: l.action,
      Tür: l.type,
      Zaman: l.created_at,
      Detay: l.details
    })));
    const csv = XLSXUtils.sheet_to_csv(ws);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'islem_kayitlari.csv'; a.click();
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
  }
  function exportPDF() {
    window.print(); // Basit çözüm: PDF olarak yazdır
  }

  return (
    <div className="w-full p-6">
      <h1 className="text-3xl font-bold text-blue-900 mb-8 flex items-center gap-3 px-6 pt-6">
        <HiOutlineDocumentText className="w-8 h-8 text-blue-700" /> İşlem Kayıtları (Logs)
      </h1>
      {/* Filtreler */}
      <div className="flex flex-wrap gap-4 mb-6 px-6 items-end">
        <div className="flex gap-2 mb-2">
          <button className="px-4 py-2 rounded bg-green-600 text-white font-semibold hover:bg-green-700 transition text-xs" onClick={exportExcel}>Excel</button>
          <button className="px-4 py-2 rounded bg-blue-600 text-white font-semibold hover:bg-blue-700 transition text-xs" onClick={exportCSV}>CSV</button>
          <button className="px-4 py-2 rounded bg-gray-600 text-white font-semibold hover:bg-gray-700 transition text-xs" onClick={exportPDF}>PDF</button>
        </div>
        <div>
          <label className="block text-xs text-blue-900 font-semibold mb-1">Arama</label>
          <input type="text" className="px-3 py-2 rounded border border-blue-200 bg-white text-blue-900" placeholder="Kullanıcı, işlem, detay..." value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <div>
          <label className="block text-xs text-blue-900 font-semibold mb-1">Sırala</label>
          <select className="px-3 py-2 rounded border border-blue-200 bg-white text-blue-900" value={sortBy + '-' + sortDir} onChange={e => { const [by, dir] = e.target.value.split('-'); setSortBy(by); setSortDir(dir); }}>
            <option value="created_at-desc">En Yeni</option>
            <option value="created_at-asc">En Eski</option>
            <option value="user-asc">Kullanıcı (A-Z)</option>
            <option value="user-desc">Kullanıcı (Z-A)</option>
            <option value="type-asc">Tür (A-Z)</option>
            <option value="type-desc">Tür (Z-A)</option>
          </select>
        </div>
        <div>
          <label className="block text-xs text-blue-900 font-semibold mb-1">Kullanıcı</label>
          <select className="px-3 py-2 rounded border border-blue-200 bg-white text-blue-900" value={userFilter} onChange={e => setUserFilter(e.target.value)}>
            <option value="">Tümü</option>
            {userOptions.map(u => <option key={u} value={u}>{u}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-xs text-blue-900 font-semibold mb-1">İşlem Türü</label>
          <select className="px-3 py-2 rounded border border-blue-200 bg-white text-blue-900" value={typeFilter} onChange={e => setTypeFilter(e.target.value)}>
            <option value="">Tümü</option>
            {typeOptions.map(t => <option key={t} value={t}>{t === 'add' ? 'Ekleme' : t === 'delete' ? 'Silme' : t === 'update' ? 'Düzenleme' : t}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-xs text-blue-900 font-semibold mb-1">Başlangıç Tarihi</label>
          <input type="date" className="px-3 py-2 rounded border border-blue-200 bg-white text-blue-900" value={dateFrom} onChange={e => setDateFrom(e.target.value)} />
        </div>
        <div>
          <label className="block text-xs text-blue-900 font-semibold mb-1">Bitiş Tarihi</label>
          <input type="date" className="px-3 py-2 rounded border border-blue-200 bg-white text-blue-900" value={dateTo} onChange={e => setDateTo(e.target.value)} />
        </div>
        {(userFilter || typeFilter || dateFrom || dateTo) && (
          <button className="px-4 py-2 rounded bg-gray-200 text-blue-900 font-semibold hover:bg-gray-300 transition text-xs mt-4" onClick={() => { setUserFilter(''); setTypeFilter(''); setDateFrom(''); setDateTo(''); }}>Filtreleri Temizle</button>
        )}
      </div>
      <div className="bg-white rounded-2xl shadow-xl p-8 border border-blue-100">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="bg-blue-50 text-blue-900">
              <th className="px-3 py-2 text-left">Kullanıcı</th>
              <th className="px-3 py-2 text-left">İşlem</th>
              <th className="px-3 py-2 text-left">Tür</th>
              <th className="px-3 py-2 text-left">Zaman</th>
              <th className="px-3 py-2 text-left">Özet</th>
            </tr>
          </thead>
          <tbody>
            {filteredLogs.map(log => (
              <tr key={log.id} className="border-b last:border-b-0">
                <td className="px-3 py-2 flex items-center gap-2 text-blue-900 font-semibold"><HiOutlineUser className="w-5 h-5 text-blue-400" /> {log.user}</td>
                <td className="px-3 py-2">{log.action}</td>
                <td className="px-3 py-2">
                  <span className={`px-2 py-1 rounded-full text-xs font-bold ${log.type === 'add' ? 'bg-green-100 text-green-800' : log.type === 'delete' ? 'bg-red-100 text-red-700' : log.type === 'update' ? 'bg-yellow-100 text-yellow-800' : 'bg-blue-100 text-blue-800'}`}>
                    {log.type === 'add' ? 'Ekleme' : log.type === 'delete' ? 'Silme' : log.type === 'update' ? 'Düzenleme' : log.type}
                  </span>
                </td>
                <td className="px-3 py-2 flex items-center gap-2 text-blue-800"><HiOutlineClock className="w-4 h-4 text-blue-400" /> {log.created_at ? new Date(log.created_at).toLocaleString() : ''}</td>
                <td className="px-3 py-2">
                  <button className="px-3 py-1 rounded bg-blue-100 text-blue-700 hover:bg-blue-200 text-xs font-semibold" onClick={() => setSelectedLog(log)}>
                    İşlem Özeti
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Detay Modalı */}
      {selectedLog && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md flex flex-col gap-4 border border-blue-100 relative animate-fade-in">
            <button className="absolute top-4 right-4 text-blue-900 text-2xl font-bold hover:text-red-600" onClick={() => setSelectedLog(null)}>&times;</button>
            <div className="font-bold text-blue-900 text-lg mb-2">İşlem Detayı</div>
            {/* Detayları ayrıştır ve vurgulu göster */}
            <LogDetails details={selectedLog.details} />
            <div className="flex gap-2 text-xs text-blue-700 mt-2 flex-wrap">
              <span><b>Kullanıcı:</b> {selectedLog.user}</span>
              <span><b>Zaman:</b> {selectedLog.created_at ? new Date(selectedLog.created_at).toLocaleString() : ''}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// Detayları anahtar:değer olarak ayrıştırıp tablo ve badge ile gösteren yardımcı component
function LogDetails({ details }) {
  if (!details) return null;
  // Satırları ayır
  const lines = details.split(/\r?\n/).filter(Boolean);
  // Anahtar:değer ayrıştır
  const parsed = lines.map(line => {
    const idx = line.indexOf(':');
    if (idx === -1) return { key: '', value: line };
    return { key: line.slice(0, idx).trim(), value: line.slice(idx + 1).trim() };
  });
  // IP ve cihaz bilgisi badge olarak, eski/yeni değerler tablo olarak
  const ip = parsed.find(x => x.key.toLowerCase().includes('ip'));
  const device = parsed.find(x => x.key.toLowerCase().includes('cihaz'));
  const oldVal = parsed.find(x => x.key.toLowerCase().includes('eski'));
  const newVal = parsed.find(x => x.key.toLowerCase().includes('yeni'));
  const rest = parsed.filter(x => x !== ip && x !== device && x !== oldVal && x !== newVal);
  return (
    <div className="flex flex-col gap-2">
      {ip && <span className="inline-block bg-blue-50 text-blue-700 px-2 py-1 rounded text-xs font-semibold w-fit">IP: {ip.value}</span>}
      {device && <span className="inline-block bg-blue-50 text-blue-700 px-2 py-1 rounded text-xs font-semibold w-fit">Cihaz: {device.value}</span>}
      {(oldVal || newVal) && (
        <table className="min-w-full text-xs border mb-2">
          <thead><tr><th className="border px-2 py-1">Eski Değer</th><th className="border px-2 py-1">Yeni Değer</th></tr></thead>
          <tbody><tr><td className="border px-2 py-1">{oldVal?.value || '-'}</td><td className="border px-2 py-1">{newVal?.value || '-'}</td></tr></tbody>
        </table>
      )}
      <table className="min-w-full text-xs">
        <tbody>
          {rest.map((x, i) => x.key && (
            <tr key={i}><td className="pr-2 py-1 text-blue-900 font-semibold whitespace-nowrap">{x.key}:</td><td className="py-1 text-blue-800">{x.value}</td></tr>
          ))}
        </tbody>
      </table>
    </div>
  );
} 